<template>
<!--this is gonna contain all the steps for a given product-->
    <LcForm :formData="formData"
        :formSettings="formSettings"
        :productName="props.productName"
        @completed.once="componentSettings.isCompleted = true"
    />
</template>

<script setup>

import { reactive, onMounted } from 'vue';

// this is the new 2025 version of InitialFlow.vue
import LcForm from '@/components/form/LcForm.vue';
import { getSteps } from "@/form/helpers/steps-per-product.js";
import { useComponentProps } from '@/composables/useComponentProps.js';
import { useInjectedApplicationSettings } from '@/composables/useApplicationSettingsProvider.js';
import { DEFAULT_FORM_SETTINGS } from '@/constants/form-settings.js';

const props = defineProps({
    productName: {
        type: String,
        default: 'personal_loan',
    },
    componentSettings: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['update:componentSettings']);

const { componentSettings } = useComponentProps(props, emit, ['componentSettings']);

const applicationSettings = useInjectedApplicationSettings();
const formSettings = DEFAULT_FORM_SETTINGS;

const formData = reactive({
    steps: null,
    onSubmit: true,
});

// created
formData.steps = getSteps(props.productName, applicationSettings.country ?? 'CA');

onMounted(() => {
    applicationSettings.loadingAnimationSeconds = 0;
});

</script>
